import { withErrorBoundary } from 'react-error-boundary';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const Container = (Component) => {
  const WrappedComponent = (props) => {
    return (
      <Stack my={5} gap={5} id={props?.id}>
        <Component {...props} />
      </Stack>
    );
  };

  return withErrorBoundary(WrappedComponent, {
    FallbackComponent: () => (
      <Box my={8} width="100%">
        <Typography variant="h5" component="p" align="center">
          "Não foi possível carregar o gráfico."
        </Typography>
      </Box>
    ),
  });
};

export default Container;
